import { Box, Flex, Heading, SimpleGrid, Text } from '@chakra-ui/react';
import { headerHeight } from '@udacity/udacity-header-v2';

import { ContentContainer } from '~/components/container';
import { ComingSoonCard } from '~/features/ai-marketer/components/coming-soon-card';
import { AI_MARKETER_ANALYTICS_EVENT, COPY, START_LEARNING_SECTION_ID } from '~/features/ai-marketer/constants';
import { trackEvent } from '~/features/analytics/track-event';
import { CatalogItem } from '~/features/catalog/models/catalog-item';
import { CatalogCard } from '~/features/experiments/ab_plp_redesign_2025/components/catalog-card';

export function StartLearningSection({ programs }: { programs: CatalogItem[] }) {
  return (
    <Box
      as='section'
      bg='grey.50'
      id={START_LEARNING_SECTION_ID}
      pb={{ base: '40px', md: '80px' }}
      pt={{ base: '56px', md: '96px' }}
      scrollMarginTop={headerHeight}
    >
      <ContentContainer contentMaxWidth='content-max-width-md'>
        <Flex
          alignItems='center'
          flexDirection='column'
          gap='16px'
          mb={{ base: '32px', md: '48px' }}
          textAlign='center'
        >
          <Heading
            as='h2'
            color='grey.900'
            letterSpacing='-0.02em'
            size={{ base: 'mobile-heading-2', md: 'heading-2' }}
          >
            {COPY.startLearning.title}
          </Heading>
          <Text color='grey.500' fontSize='md' maxWidth='842px'>
            {COPY.startLearning.description}
          </Text>
        </Flex>
        <SimpleGrid columns={{ base: 2, md: 3 }} maxWidth='816px' mx='auto' spacing={{ base: '12px', md: '24px' }}>
          <ComingSoonCard />
          {programs.map((program) => (
            <CatalogCard
              key={program.key}
              catalogItem={program}
              onClick={() =>
                trackEvent({
                  type: 'click',
                  name: AI_MARKETER_ANALYTICS_EVENT,
                  label: 'catalog_card_clicked',
                  value: program.title ?? undefined,
                  additionalAttributes: {
                    product_ids: [program.key],
                  },
                })
              }
            />
          ))}
        </SimpleGrid>
      </ContentContainer>
    </Box>
  );
}
